export function vtcertificadosInRequest(params = {}) {
    return {
        type: '@vtcertificados/VTCERTIFICADOS_IN_REQUEST',
        payload: { params },
    };
}

export function failedRequest() {
    return {
        type: '@vtcertificados/FAILED_REQUEST',
    };
}

export function successInRequest(
    vtcertificados,
    page,
    pageSize,
    totalCount,
    totalPages
) {
    return {
        type: '@vtcertificados/SUCCESS_IN_REQUEST',
        payload: { vtcertificados, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(vtcertificados) {
    return {
        type: '@vtcertificados/SUCCESS_REQUEST',
        payload: { vtcertificados },
    };
}

export function successRemove(params) {
    return {
        type: '@vtcertificados/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@vtcertificados/RECORD_FILTERING',
        payload: { params },
    };
}
